import types from 'actions/types'
import { combineReducers } from 'redux'

const open = (state = false, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SHOW_ITEM_DRAWER: return true
    case types.INVOICING_INVOICE_HIDE_ITEM_DRAWER: return false
    case types.INVOICING_LOAD_INVOICE_ATTEMPT: return false
    default: return state
  }
}

const invoiceItem = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SHOW_ITEM_DRAWER: return action.invoiceItem
    case types.INVOICING_INVOICE_HIDE_ITEM_DRAWER: return null
    default: return state
  }
}

const index = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_INVOICE_SHOW_ITEM_DRAWER: return action.index
    case types.INVOICING_INVOICE_HIDE_ITEM_DRAWER: return null
    default: return state
  }
}

export default combineReducers({
  open,
  invoiceItem,
  index,
})
